import styled from "styled-components";

interface IClientBudgetProps {
  setBudget: React.Dispatch<React.SetStateAction<number | null>>;
  disabled: boolean;
}

export const ClientBudget = ({ setBudget, disabled }: IClientBudgetProps) => {
  return (
    <div>
      <InputWrapper>
        <Label htmlFor="budgetInput">Kundbudget​</Label>
        <Input
          type="number"
          name="budgetInput"
          onChange={(e) =>
            e.target.value === "" || e.target.value === "0"
              ? setBudget(null)
              : setBudget(parseInt(e.target.value))
          }
          disabled={disabled}
          min="0"
        />
      </InputWrapper>
    </div>
  );
};

const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

const Input = styled.input<{ disabled: boolean }>`
  background-color: ${(p) => (p.disabled ? "#f1f1f1" : "#00a0d6")};
  border: 2px solid #45d0ff;
  border-radius: 15px;
  height: 30px;
  padding: 10px;
  color: #fff;
  font-size: 16px;
`;

const Label = styled.label`
  color: #00a0d6;
  font-size: 18px;
  margin-bottom: 5px;
`;
